export enum SortDirection {
    descending = "descending",
    ascending = "ascending",
}

export interface ISortOutput {
    actionName: string;
    direction: SortDirection;
}

export interface ISortLabels {
    code: string;
    label: string;
}
